import styled from 'styled-components';
import { SwiperSlide } from 'swiper/react';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
`;

export const Slide = styled(SwiperSlide)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SwiperWrapper = styled.div`
  width: 100%;
  max-height: 60vh; // ocupa no máximo 60% da altura da tela
  overflow: hidden;

  img {
    max-width: 100%;
    max-height: 60vh;
    object-fit: contain;
    border-radius: 8px;
  }
`;

export const InfoPrincipal = styled.section`
  margin-top: 2rem;
`;

export const Titulo = styled.h1`
  gap: 0.5rem;
  font-size: 2rem;
  margin-bottom: 0.5rem;
`;

export const Endereco = styled.p`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1rem;
  color: var(--secondary);
  margin: 0 auto;
  text-align: center;
`;

export const Preco = styled.h2`
  font-size: 1.8rem;
  color: var(--gold);
  margin: 1rem 0;
`;

export const Detalhes = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

export const DetalheItem = styled.li`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  font-size: 0.95rem;
`;

export const Acoes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

export const Descricao = styled.section`
  margin-top: 3rem;

  h3 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  p {
    line-height: 1.6;
    color: var(--secondary);
    white-space: pre-line; /* Esta linha garante que \n seja exibido como quebra de linha */
  }
`;

export const Localizacao = styled.section`
  margin-top: 3rem;

  h3 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  p {
    margin-bottom: 1rem;
    color: var(--secondary);
  }
`;

export const MapaBotao = styled.button`
  background-color: #388e3c;
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background-color: #2e7d32;
  }
`;
